import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { FaSearch, FaLocationArrow, FaPlus } from 'react-icons/fa';
import { IoLocationSharp } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const defaultPosition = [19.2183, 72.9781]; // Azad Nagar coords as default

const LocationMarker = ({ setLocation }) => {
  useMapEvents({
    click(e) {
      setLocation([e.latlng.lat, e.latlng.lng]);
    }
  });
  return null;
};

const SearchForLocation = () => {
  const [location, setLocation] = useState(defaultPosition);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate()
  
  const suggestions = [
    { name: 'Anand Nagar, Thane West', desc: 'Thane, Maharashtra, India' },
    { name: 'Anand Nagar, Dahisar East', desc: 'Mumbai, Maharashtra, India' },
    { name: 'Anand Nagar, Mulund East', desc: 'Mumbai, Maharashtra, India' },
  ];

  const filtered = suggestions.filter(loc => loc.name.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className="min-h-screen bg-white text-black font-sans">
                         
      {/* Map View */}
      <div className="h-56 w-full relative">
      <div onClick={()=>navigate(-1)} 
      className="absolute top-2 left-2 z-[999] bg-black text-white rounded-full p-2 shadow-md cursor-pointer"
        >
                          <ArrowLeft />
                          </div>
        <MapContainer center={location} zoom={14} scrollWheelZoom={true} className="h-full z-0">
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={location}></Marker>
          <LocationMarker setLocation={setLocation} />
        </MapContainer>
      </div>

      {/* Search Box */}
      <div className="relative p-4 bg-white text-gray-800 z-10 shadow-sm">
        <input
          type="text"
          placeholder="Enter your area or apartment name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full py-2 px-4 pl-10 border border-gray-400 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#21a6e9]"
        />
        <FaSearch className="absolute top-[2.5rem] left-7 text-gray-600" />
      </div>

      {/* Options */}
      <div className="px-4 pt-2">
        <div onClick={()=>{navigate('/customer-home-page')}} className="flex items-center text-[#21a6e9] py-2 space-x-2 cursor-pointer">
          <FaLocationArrow />
          <p>Use my current location</p>
        </div>
        {/* <div className="flex items-center text-[#ff6a00] py-2 space-x-2 cursor-pointer">
          <FaPlus />
          <p>Add new address</p>
        </div> */}
      </div>

      {/* Suggestions */}
      <div className="px-4">
        <h2 className="text-xs text-gray-500 mt-4 mb-3">SEARCH RESULTS</h2>
        {filtered.map((loc, index) => (
          <div key={index} className="py-2 border-b flex items-start space-x-3 cursor-pointer">
            <IoLocationSharp className="text-lg text-gray-600 mt-1" />
            <div>
              <p className="text-sm font-semibold">{loc.name}</p>
              <p className="text-xs text-gray-500">{loc.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchForLocation;
